module.exports = __webpack_public_path__ + "static/media/logo-코비젼@3x.2c54d80e.png";